import { DeleteAction, EditAction } from "@/components/Action";
import { ListCountry } from "@/constants/country";
import { DATE_FORMAT, ListTypeTa } from "@/constants/default";
import { EnumTypeTa } from "@/constants/enum";
import { usePermissions } from "@/rbac";
import { permissions } from "@/rbac/permissions";
import { Tenant } from "@/types/tenant.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { classNameTenantFinExpiry } from "@/utils/helper";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function TableHeader(): ColumnDef<Tenant>[] {
    const {t} = useTranslation();
    const { hasPermission } = usePermissions();
    const navigate = useNavigate()
    const location = useLocation()

    return [
        // {
        //     header: t("tenant.no"),
        //     accessorKey: "no"
        // },
        {
            header: t("tenant.name"),
            accessorKey: "name"
        },
        {
            header: t("tenant.email"),
            accessorKey: "email"
        },
        {
            header: t("tenant.contact_no"),
            accessorKey: "contact_no"
        },
        {
            header: t("tenant.access_card"),
            accessorKey: "access_card"
        },
        {
            header: t("tenant.gender"),
            accessorKey: "gender",
            cell: ({ row }) => row.original.gender === 1 ? "Male" : "Female"
        },
        {
            header: t("tenant.identity_number"),
            accessorKey: "identity_number",
            cell: ({ row }) => row.original.identity_number || ""
        },
        {
            header: t("tenant.fin_expiry"),
            accessorKey: "fin_expiry",
            meta: {
                className: "!px-0 !py-0 min-w-26 w-26"
            },
            cell: ({row}) => {
                const type = ListTypeTa().find(i => i.value === row.original.type)
                return type?.value < EnumTypeTa.NORMAL ? <div className="py-2 px-2 dark:text-white">{type?.label}</div> : <div className={`py-2 px-2 dark:text-white ${classNameTenantFinExpiry(row.original.fin_expiry)}`}>
                    {
                        row.original.fin_expiry ? formatDateTimeAutoToString(row.original.fin_expiry ?? '', "ll") : "N/A"
                    }
                </div>
            }
        },
        {
            header: t("tenant.nationality"),
            accessorKey: "nationality",
            cell: ({row}) => ListCountry().find(i => i.value === row.original.nationality)?.label || ""
        },
        {
            header: t("table.created_at"),
            accessorKey: "created_at",
            cell: ({ row }) => formatDateTimeAutoToString(row.original.created_at, DATE_FORMAT)
        },
        {
            header: t("table.action"),
            accessorKey: "action",
            enableSorting: false,
            cell: ({ row }) => (
                <div className="flex items-center space-x-3.5">
                    {
                        hasPermission(permissions.TENANT.EDIT) && <EditAction onClick={() => navigate(location , {state: {modal: "/settings/tenants/edit", id: row.original.id}})} />
                    }
                    {
                        hasPermission(permissions.TENANT.DELETE) && <DeleteAction onClick={() => navigate(location , {state: {modal: "/settings/tenants/delete", id: row.original.id}})} />
                    }
                </div>
            )
        }
    ]
}